import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { Product } from "..";
import GlobalContext from "../../../../global-context";

type PrivatePriceTablesProps = {
  privatePrices: NonNullable<Product>["privatePrices"];
  defaultMaximumInGroup: NonNullable<Product>["defaultMaximumInGroup"];
};

export default function PrivatePriceTable({
  privatePrices,
  defaultMaximumInGroup,
}: PrivatePriceTablesProps) {
  const globalContext = useContext(GlobalContext);

  return (
    <Table sx={{ width: "unset" }} size="small">
      <TableHead>
        <TableRow>
          {["Min", "Max", "Price"].map((header) => (
            <TableCell key={header} sx={{ paddingTop: 0, paddingBottom: 0 }}>
              {header}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {privatePrices &&
          privatePrices.length > 0 &&
          privatePrices.map((price, index) => {
            const maxGroupSize =
              (privatePrices[index + 1]?.minGroupSize ?? defaultMaximumInGroup + 1) -
              1;
            return (
              price.price && (
                <TableRow
                  key={price.id}
                  id={price.id}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                      paddingBottom: 0,
                    },
                  }}
                >
                  <TableCell>
                    <Typography>{price.minGroupSize}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>{maxGroupSize}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography fontWeight="bold">
                      {Intl.NumberFormat("ja-JP", {
                        style: "currency",
                        currency: globalContext.currency,
                      }).format(price.price || 0)}
                    </Typography>
                  </TableCell>
                </TableRow>
              )
            );
          })}
      </TableBody>
    </Table>
  );
}
